import {AR_V2, STAGE_LOCATION_TYPE} from "./Constants";

const OVERFLOW_LOCATION_SUFFIX = " (Overflow)";

/**
 * Returns staging location of route.
 * Pre-requisite: transformStagingLocations should be executed on route before this method.
 *
 * @param rswsRoute - response route obj from rsws
 */
export function getRouteStagingLocation(rswsRoute) {
    if(rswsRoute.stagingLocations.length){
        return rswsRoute.stagingLocations.map(location => location.displayLabel).join(", ");
    }
    return "...";
}

/**
 * Returns staging location of cart.
 * Pre-requisite: transformStagingLocations should be executed on route before this method.
 *
 * @param route - response route obj from rsws
 * @param cart - cart from SVS/RSWS
 * @param capability - station capability
 */
export function getCartStagingLocation(route, cart, capability) {
    if (capability === AR_V2) {
        if (route.stagingLocation && route.stagingLocation !== "...") {
            return route.stagingLocation;
        } else {
            return cart.floorLocation ? cart.floorLocation : "...";
        }
    } else {
        if (cart.stagingLocation) {
            return getDisplayLabel(cart.stagingLocation);
        } else if (cart.stageTime) {
            return route.stagingLocation;
        } else {
            return cart.preStageLocation;
        }
    }
}


/**
 * Returns floor location of cart.
 *
 * @param cart - cart from SVS/RSWS
 * @param capability - station capability
 */
export function getCartFloorLocation(cart, capability) {
    if (capability === AR_V2 && cart.floorLocation && cart.floorLocation !== "...") {
        return cart.floorLocation;
    }
    else {
        return null;
    }
}

/**
 * Returns parsed staging locations list for route.
 * @param rswsRoute
 * @return {*[]|{displayLabel: (null|string|*), label: (null|string|*), type: string}[]|*}
 */
export function transformStagingLocations(rswsRoute) {
    if (Array.isArray(rswsRoute.stagingLocations) && rswsRoute.stagingLocations.length) {
        return rswsRoute.stagingLocations.map(location => {
            return {
                label: location.label,
                type: location.type,
                displayLabel: getDisplayLabel(location)
            }
        })
    } else if (rswsRoute.stagingLocation && rswsRoute.stagingLocation !== "...") {
        return [{
            label: rswsRoute.stagingLocation,
            displayLabel: rswsRoute.stagingLocation,
            type: STAGE_LOCATION_TYPE.NORMAL,
        }]
    }
    return [];
}

function getDisplayLabel(location) {
    if (location.type === STAGE_LOCATION_TYPE.OVERFLOW) {
        return `${location.label}${OVERFLOW_LOCATION_SUFFIX}`
    } else {
        return location.label;
    }
}


// WEBPACK FOOTER //
// ./src/components/util/DataTransformUtil.js